import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Fashion%20lifestyle%20flatlay%20with%20diverse%20premium%20clothing%20items%20and%20accessories%20arranged%20on%20light%20marble%20surface%2C%20natural%20daylight%20from%20large%20windows%2C%20warm%20cream%20and%20taupe%20color%20palette%2C%20soft%20linen%20fabric%20texture%2C%20minimalist%20aesthetic%2C%20editorial%20fashion%20photography%2C%20clean%20and%20airy%20atmosphere%2C%20subtle%20elegant%20styling%2C%20organic%20composition%20with%20natural%20shadows&width=1920&height=1080&seq=hero-bg-new-2026-v2&orientation=landscape"
          alt="USFans Spreadsheet - produkty"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-16">
        <div className="max-w-2xl">
          <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-heading font-bold text-white leading-tight animate-fade-in-up" style={{ textShadow: '0 2px 8px rgba(0,0,0,0.3)' }}>
            USFans Spreadsheet
          </h1>
          <p className="text-lg md:text-xl lg:text-2xl text-white/90 mt-4 md:mt-6 font-light leading-relaxed animate-fade-in-up animation-delay-200" style={{ textShadow: '0 1px 4px rgba(0,0,0,0.3)' }}>
            Kompletny przewodnik, aktualizacje i zasoby
          </p>
          <p className="text-sm md:text-base text-white/70 mt-3 md:mt-4 max-w-lg leading-relaxed animate-fade-in-up animation-delay-400">
            Poznaj najnowsze informacje, poradniki, porównania oraz praktyczne wskazówki dotyczące USFans Spreadsheet.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 mt-8 animate-fade-in-up animation-delay-600">
            <Link
              to="/artykul/usfans-spreadsheet-kompletny-przewodnik"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-white/15 backdrop-blur-sm border border-white/30 text-white font-medium text-sm hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Sprawdź przewodnik
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/artykul/usfans-spreadsheet-poradnik-zakupowy"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-white/10 backdrop-blur-sm border border-white/30 text-white font-medium text-sm hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Poradnik zakupowy
              <i className="ri-shopping-bag-3-line"></i>
            </Link>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-white text-foreground-900 font-semibold text-sm hover:bg-white/90 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Kup teraz
              <i className="ri-shopping-bag-line"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 z-10 pb-6 md:pb-10">
        <div className="flex items-center gap-6 md:gap-8 px-4 md:px-8 lg:px-16 text-white/70 text-xs md:text-sm">
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-400"></i>
            Aktualizowane regularnie
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-400"></i>
            Bezpieczne informacje
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-400"></i>
            Darmowe poradniki
          </span>
        </div>
      </div>
    </section>
  );
}